export default __webpack_public_path__ + "static/media/flag-togo.8c7ff8db.svg";